/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Configurator_Page_TitleInputs */

const de_configurator_page_title = /** @type {(inputs: Configurator_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket konfigurieren`)
};

/** @type {(inputs: Configurator_Page_TitleInputs) => LocalizedString} */
const en_configurator_page_title = de_configurator_page_title;

/**

* @param {Configurator_Page_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const configurator_page_title = /** @type {((inputs?: Configurator_Page_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Configurator_Page_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_configurator_page_title(inputs)
	return en_configurator_page_title(inputs)
});